import React, { createContext, useState, useEffect } from 'react';
import { theme } from 'antd';

export const ThemeContext = createContext({
  themeConfig: {
    algorithm: theme.defaultAlgorithm,
    token: {},
  },
  toggleTheme: () => {},
  changeLocale: () => {},
});

export const ThemeProvider = ({ children }) => {
  const [themeConfig, setThemeConfig] = useState({
    algorithm: theme.defaultAlgorithm,
    token: {
      colorPrimary: '#005EB8',
      borderRadius: 8,
    },
  });

  const toggleTheme = () => {
    setThemeConfig(prev => ({
      ...prev,
      algorithm: prev.algorithm === theme.defaultAlgorithm ? theme.darkAlgorithm : theme.defaultAlgorithm,
    }));
  };

  const changeLocale = (locale) => {
    // Implement locale change logic here if needed
  };

  return (
    <ThemeContext.Provider value={{ themeConfig, toggleTheme, changeLocale }}>
      {children}
    </ThemeContext.Provider>
  );
}; 